import LocalizedStrings from 'react-localization';

export const languageCodes = Object.freeze({
  en: {
    code: "en",
    label: "English"
  },
  id: {
    code: "id",
    label: "Indonesian"
  },
  th: {
    code: "th",
    label: "Thai"
  },
  pt: {
    code: "pt",
    label: "Portuguese"
  },
  es: {
    code: "es",
    label: "Spanish"
  },
  fr: {
    code: "fr",
    label: "French"
  },
});

export const strings = new LocalizedStrings({
  en: { // English
    language: "Language",
    nitrogenTitle: "Total nitrogen exports (organic + mineral), tons/year",
    phosphorusTitle: "Total phosphorus exports (organic + mineral), tons/year",
    nitrogenBarTitle: "Nitrogen balance (kg N per year)",
    excretion: "Excretion",
    regeneration: "Regeneration",
    algae: "Algae",
    naturalAreas: "Natural Areas",
    annualCrops: "Annual Crops",
    permanentCrops: "Permanent Crops",
    wastewaterUrbanAreas: "Wastewater (from urban areas)",
    region: "Region",
    subbasin: "Subbasin",
    aquascapeSustainableCarryingCapacity: "Aquascape Sustainable Carrying Capacity",
    flowM3S: "Flow (m3/s)",
    lengthMeters: "Length (meters)",
    totalNitrogenConcentrationOrganicMineral: "Total Nitrogen concentration (organic + mineral), in mg/L",
    totalPhosphorusConcentrationOrganicMineral: "Total Phosphorus concentration (organic + mineral), in mg/L",
    contextDescr: "Aquaculture analytics for regulators, farmers and supply chains",
    selectLayersToTheRight: "Select carrying capacity, land, ocean and aquaculture layers in the left sidebar",
    hoverOverAreasOfInterestForMoreInformation: "Hover over areas of interest for AquaScape analytics",
    clickAreaOfInterestToLockInformationInTheContextBar: "Click area of interest to lock information in the context bar",
    zones: "Zones",
    carryingCapacity: "Carrying Capacity",
    regions: "Regions",
    subbasins: "Subbasins",
    streams: "Streams",
    land: "Land",
    oceans: "Oceans",
    bathymetry: "Bathymetry",
    aquaculture: "Aquaculture",
    patasPonds: "Patas Ponds",
    pegamatanPonds: "Pegamatan Ponds",
    pegamatanCages: "Pegamatan Cages",
    fishFarming: "Fish farming",
    shrimpFarmingWestBali: "Shrimp Farming West Bali",
    shrimpFarmingEastBali: "Shrimp Farming East Bali",
    watershed: "Watershed",
    partners: "Partners",
    donors: "Donors",
    landCover: "Land Cover",
    all: "All",
    cornFields: "Corn fields",
    riceFields: "Rice fields",
    forests: "Forests",
    urbanAreas: "Urban areas",
    coffeeAndCoconutPlantations: "Coffee and coconut plantations",
    bareSoils: "Bare soils",
    shrub: "Shrub",
    wetlands: "Wetlands",
    fishPonds: "Fish ponds",
    fishCages: "Fish cages",
    fishProduction: "Fish production",
    fishing: "Recreational fishing",
    shrimpPonds: "Shrimp ponds",
    crabPonds: "Crab ponds",
    selectLayersOnTheLeftSidebar: "Select layers on the left sidebar",
    palm: "Palm",
    intensive: "Intensive",
    semi: "Semi",
    extensive: "Extensive",
    settling: "Settling",
    reservoir: "Reservoir",
    dormant: "Dormant",
    wastewaterTreatment: "Wastewater treatment",
    waterTreatment: "Water treatment",
    abandoned: "Abandoned",
    inactive: "Inactive",
    outlet: "Outlet",
    policulture: "Policulture",
    recreational: "Recreational",
    superIntensive: "Super intensive",
    eelPonds: "Eel ponds",
    softShellCrabPonds: "Soft shell crab ponds",
    grouperPonds: "Grouper ponds",
    snapperPonds: "Snapper ponds",
    country: "Country",
    continent: "Continent",
    species: "Species",
    regency: "Regency",
    areaM2: "Area (m2)",
    volM3: "Vol (m3)",
    district: "District",
    hectares: "Hectares", 
    province: "Province",
    estimatedProductionKgPerYear: "Estimated production (kg per year)",
    totalStockInd: "Total stock (ind.)",
    areaHa: {
      "bali": ["Land use area (hectares)", "Buleleng, Bali"], 
      "java": ["Land use area (hectares)", "Banyuwangi, East Java"]
    }, 
    totalNLoadsTonY: {
      "bali": ["Nitrogen loads by land use (tonnes/year)", "Buleleng, Bali"], 
      "java": ["Nitrogen loads by land use (tonnes/year)", "Banyuwangi, East Java"]
    },
    externalitiesKUsdY: {
      "bali": ["Externalities (K USD/Y)", "Buleleng, Bali"], 
    },
    shrimpAquacultureByType: {
      "java": ["Shrimp aquaculture by type (number)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureAreaHa: {
      "java": ["Shrimp aquaculture areas (hectares)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureTotalNLoads: {
      "java": ["Shrimp aquaculture nitrogen loads (tonnes/year)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureProduction: {
      "java": ["Shrimp aquaculture production (tonnes/year)", "Banyuwangi, East Java"]
    }, 
    shrimpAquaculture: "Shrimp aquaculture",
    ammonia: "Ammonia",
    din: "DIN",
    phytoplanktonBiomass: "Phytoplankton Biomass",
    zooplanktonBiomass: "Zooplankton Biomass",
  },
  id: { // Indonesian
    language: "Bahasa",
    nitrogenTitle: "Total masukan nitrogen (organik + mineral), ton/tahun",
    phosphorusTitle: "Total masukan fosforus (organik + mineral), ton/tahun",
    nitrogenBarTitle: "Kesetimbangan Nitrogen (kg N per tahun)",
    excretion: "Ekskresi",
    regeneration: "Regenerasi",
    algae: "Alga",
    naturalAreas: "Area hutan",
    annualCrops: "Area pertanian musiman",
    permanentCrops: "Area pertanian permanen",
    wastewaterUrbanAreas: "Limbah rumah tangga",
    region: "Daerah",
    subbasin: "Subbasin",
    aquascapeSustainableCarryingCapacity: "Daya Dukung Akuakultur Berkelanjutan",
    flowM3S: "Debit air (m3/s)",
    lengthMeters: "Panjang (meter)",
    totalNitrogenConcentrationOrganicMineral: "Total konsentrasi nitrogen (organik + mineral), dalam mg/L",
    totalPhosphorusConcentrationOrganicMineral: "Total konsentrasi fosforus (organik + mineral), dalam mg/L",
    contextDescr: "Analisis akuakultur untuk regulator, petani, dan rantai pasokan",
    selectLayersToTheRight: "Pilih daya dukung, tanah, laut dan lapisan budidaya di sidebar kiri",
    hoverOverAreasOfInterestForMoreInformation: "Arahkan kursor ke area yang diminati untuk analitik AquaScape",
    clickAreaOfInterestToLockInformationInTheContextBar: "Klik pada area yang diinginkan untuk mengunci informasi pada bilah konteks",
    zones: "Zona",
    carryingCapacity: "Daya Dukung",
    regions: "Daerah",
    subbasins: "Subbasins",
    streams: "Sungai",
    land: "Tanah",
    oceans: "Lautan",
    bathymetry: "Batimetri",
    aquaculture: "Akuakultur",
    patasPonds: "Tambak di Patas",
    pegamatanPonds: "Tambak di Pegamatan",
    pegamatanCages: "Keramba Jaring di Pegamatan",
    fishFarming: "Budidaya Ikan",
    shrimpFarmingWestBali: "Budidaya Udang Bali Barat",
    shrimpFarmingEastBali: "Budidaya Udang Bali Timur",
    watershed: "Daerah aliran sungai",
    partners: "Partner",
    donors: "Donatur",
    landCover: "Tutupan lahan",
    all: "Semua",
    cornFields: "Ladang jagung",
    riceFields: "Ladang padi",
    forests: "Hutan",
    urbanAreas: "Area pemukiman",
    coffeeAndCoconutPlantations: "Perkebunan kopi dan kelapa",
    bareSoils: "Lahan terbuka",
    shrub: "Semak belukar",
    wetlands: "Gambut",
    fishPonds: "Kolam ikan",
    fishCages: "Keramba ikan",
    fishProduction: "Produksi ikan",
    fishing: "Memancing rekreasi",
    shrimpPonds: "Tambak udang",
    crabPonds: "Tambak kepiting",
    selectLayersOnTheLeftSidebar: "Pilih layer pada sidebar di sebelah kanan",
    palm: "Palm",
    intensive: "Intensif",
    semi: "Semi",
    extensive: "Ekstensif",
    settling: "Pengendapan",
    reservoir: "Tandon",
    dormant: "Tidak aktif",
    wastewaterTreatment: "Pengolahan air limbah",
    waterTreatment: "Pengolahan air",
    abandoned: "Terlantar",
    inactive: "Tidak aktif",
    outlet: "Outlet",
    policulture: "Polikultur",
    recreational: "Rekreasi",
    superIntensive: "Super intensif",
    eelPonds: "Kolam sidat",
    softShellCrabPonds: "Kolam kepiting soka",
    grouperPonds: "Kolam kerapu",
    snapperPonds: "Kolam kakap",
    country: "Negara",
    continent: "Benua",
    species: "Spesies",
    regency: "Kabupaten",
    areaM2: "Luas (m2)",
    volM3: "Vol (m3)",
    district: "Kecamatan",
    hectares: "Hektar", 
    province: "Provinsi",
    estimatedProductionKgPerYear: "Estimated production (kg per year)",
    totalStockInd: "Total stock (ind.)",
    areaHa: {
      "bali": ["Land use area (hectares)", "Buleleng, Bali"], 
      "java": ["Land use area (hectares)", "Banyuwangi, East Java"]
    }, 
    totalNLoadsTonY: {
      "bali": ["Nitrogen loads by land use (tonnes/year)", "Buleleng, Bali"], 
      "java": ["Nitrogen loads by land use (tonnes/year)", "Banyuwangi, East Java"]
    },
    externalitiesKUsdY: {
      "bali": ["Externalities (K USD/Y)", "Buleleng, Bali"], 
    },
    shrimpAquacultureByType: {
      "java": ["Shrimp aquaculture by type (number)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureAreaHa: {
      "java": ["Shrimp aquaculture areas (hectares)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureTotalNLoads: {
      "java": ["Shrimp aquaculture nitrogen loads (tonnes/year)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureProduction: {
      "java": ["Shrimp aquaculture production (tonnes/year)", "Banyuwangi, East Java"]
    },
    shrimpAquaculture: "Shrimp aquaculture",
    ammonia: "Ammonia",
    din: "DIN",
    phytoplanktonBiomass: "Phytoplankton Biomass",
    zooplanktonBiomass: "Zooplankton Biomass",
  },
  pt: { // Portuguese
    language: "Idioma",
		nitrogenTitle: "Saída Total de Azoto (orgânico + mineral), toneladas/ano",
		phosphorusTitle: "Saída Total de Fósforo (orgânico + mineral), toneladas/ano",
    nitrogenBarTitle: "Balanço de Azoto (kg N por ano)",
    excretion: "Excreção",
    regeneration: "Regeneração",
    algae: "Algas",
    naturalAreas: "Áreas Protegidas",
		annualCrops: "Colheitas Anuais",
		permanentCrops: "Colheitas Permanentes",
		wastewaterUrbanAreas: "Águas Residuais (provenientes de áreas urbanas)",
		region: "Região",
		subbasin: "Sub-bacia",
		aquascapeSustainableCarryingCapacity: "Aquascape Capacidade de Carga Sustentável",
		flowM3S: "Caudal (m3/s)",
		lengthMeters: "Comprimento (metros)",
		totalNitrogenConcentrationOrganicMineral: "Concentração Total de Azoto (orgânico + mineral), em mg/L",
		totalPhosphorusConcentrationOrganicMineral: "Concentração Total de Fósforo (orgânico + mineral), em mg/L",
    contextDescr: "Análise da aquicultura para reguladores, agricultores e cadeias de abastecimento",
    selectLayersToTheRight: "Selecione as camadas de capacidade de carga, terra, oceano e aquicultura na barra lateral esquerda",
		hoverOverAreasOfInterestForMoreInformation: "Passe o mouse sobre áreas de interesse para o AquaScape Analytics",
		clickAreaOfInterestToLockInformationInTheContextBar: "Carregue na área de interesse para bloquear a informação da barra de contexto",
		zones: "Zonas",
		carryingCapacity: "Capacidade de Carga",
		regions: "Regiões",
		subbasins: "Sub-bacias",
		streams: "Rios",
		bathymetry: "Batimetria",
		aquaculture: "Aquacultura",
		patasPonds: "Tanques de Patas",
		pegamatanPonds: "Tanques de Pegamatan",
		pegamatanCages: "Jaulas de Pegamatan",
		fishFarming: "Cultivo de Peixe",
		shrimpFarmingWestBali: "Culturas de Camarão em Bali Oeste",
		shrimpFarmingEastBali: "Culturas de Camarão em Bali Este",
		watershed: "Bacia Hidrográfica",
		partners: "Parceiros",
		donors: "Doadores",
    landCover: "Ocupação do Solo",
    all: "Todos",
    cornFields: "Plantação de milho",
    riceFields: "Campos de arroz",
    forests: "Florestas",
    urbanAreas: "Areas urbanas",
    coffeeAndCoconutPlantations: "Plantações de café e côco",
    bareSoils: "Solos descobertos",
    shrub: "Arbustos",
    wetlands: "Zonas pantanosas",
    fishPonds: "Tanques de peixe",
    fishCages: "Jaulas de peixe",
    fishProduction: "Produção de peixes",
    fishing: "Pesca recreativa",
    shrimpPonds: "Tanques de camarão",
    crabPonds: "Tanques de caranguejo",
    selectLayersOnTheLeftSidebar: "Seleccione camadas na barra da esquerda",
    palm: "Palma",
    intensive: "Intensivo",
    semi: "Semi",
    extensive: "Extensivo",
    settling: "Assentamento",
    reservoir: "Reserva de água",
    dormant: "Dormente",
    wastewaterTreatment: "Tratamento de águas residuais",
    waterTreatment: "Tratamento de água",
    abandoned: "Abandonado",
    inactive: "Inactivo",
    outlet: "Saída de água",
    policulture: "Policultura",
    recreational: "Recreacional",
    superIntensive: "Super intensivo",
    eelPonds: "Tanques de enguia",
    softShellCrabPonds: "Tanques de caranguejo de casca mole",
    grouperPonds: "Tanques de garoupa",
    snapperPonds: "Tanques de pargo",
    country: "País",
    continent: "Continente",
    species: "Espécies",
    regency: "Regência",
    areaM2: "Área (m2)",
    volM3: "Volume (m3)",
    district: "Distrito",
    hectares: "Hectares", 
    province: "Província",
    estimatedProductionKgPerYear: "Estimated production (kg per year)",
    totalStockInd: "Total stock (ind.)",
    areaHa: {
      "bali": ["Land use area (hectares)", "Buleleng, Bali"], 
      "java": ["Land use area (hectares)", "Banyuwangi, East Java"]
    }, 
    totalNLoadsTonY: {
      "bali": ["Nitrogen loads by land use (tonnes/year)", "Buleleng, Bali"], 
      "java": ["Nitrogen loads by land use (tonnes/year)", "Banyuwangi, East Java"]
    },
    externalitiesKUsdY: {
      "bali": ["Externalities (K USD/Y)", "Buleleng, Bali"], 
    },
    shrimpAquacultureByType: {
      "java": ["Shrimp aquaculture by type (number)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureAreaHa: {
      "java": ["Shrimp aquaculture areas (hectares)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureTotalNLoads: {
      "java": ["Shrimp aquaculture nitrogen loads (tonnes/year)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureProduction: {
      "java": ["Shrimp aquaculture production (tonnes/year)", "Banyuwangi, East Java"]
    },
    shrimpAquaculture: "Shrimp aquaculture",
    ammonia: "Ammonia",
    din: "DIN",
    phytoplanktonBiomass: "Phytoplankton Biomass",
    zooplanktonBiomass: "Zooplankton Biomass",
  },
  th: { // Thai
    language: "Language",
    nitrogenTitle: "ไนโตรเจนที่ปล่อยออกทั้งหมด (อินทรีย์+แร่ธาตุ) ตัน/ปี",
    phosphorusTitle: "ฟอสฟอรัสที่ปล่อยออกทั้งหมด (อินทรีย์+แร่ธาตุ) ตัน/ปี",
    nitrogenBarTitle: "สมดุลไนโตรเจน (กก.ไนโตรเจนต่อปี)",
    excretion: "การขับถ่ายของเสีย",
    regeneration: "การเกิดใหม่",
    algae: "สาหร่าย",
    naturalAreas: "เขตธรรมชาติ",
    annualCrops: "พืชฤดูเดียว",
    permanentCrops: "พืชยืนต้น",
    wastewaterUrbanAreas: "น้ำเสีย (จากเขตเมือง)",
    region: "ภูมิภาค",
    subbasin: "ลุ่มน้ำย่อย",
    aquascapeSustainableCarryingCapacity: "ขีดความสามารถในการรองรับอย่างยั่งยืนของภูมิทัศน์ใต้น้ำ (Aquascape)",
    flowM3S: "การไหล (ลบ.ม./วินาที)",
    lengthMeters: "ความยาว (เมตร)",
    totalNitrogenConcentrationOrganicMineral: "ความเข้มข้นไนโตรเจนทั้งหมด (อินทรีย์+แร่ธาตุ) หน่วยมิลลิกรัม/ลิตร",
    totalPhosphorusConcentrationOrganicMineral: "ความเข้มข้นฟอสฟอรัสทั้งหมด (อินทรีย์+แร่ธาตุ) หน่วยมิลลิกรัม/ลิตร",
    contextDescr: "การวิเคราะห์การเพาะเลี้ยงสัตว์น้ำสำหรับหน่วยงานกำกับดูแลเกษตรกรและซัพพลายเชน",
    selectLayersToTheRight: "เลือกความสามารถในการบรรทุกที่ดินมหาสมุทรและชั้นการเพาะเลี้ยงสัตว์น้ำในแถบด้านข้างทางซ้าย",
    hoverOverAreasOfInterestForMoreInformation: "วางเมาส์เหนือพื้นที่ที่น่าสนใจสำหรับการวิเคราะห์ AquaScape",
    clickAreaOfInterestToLockInformationInTheContextBar: "คลิ๊กพื้นที่ที่สนใจเพื่อล็อคข้อมูลในแถบตัวเลือก",
    zones: "เขตพื้นที่",
    carryingCapacity: "ขีดความสามารถในการรองรับ",
    regions: "ภูมิภาค",
    subbasins: "ลุ่มน้ำย่อย",
    streams: "ลำห้วย",
    land: "ผืนดิน",
    oceans: "มหาสมุทร",
    bathymetry: "ชั้นความลึกของน้ำทะเล",
    aquaculture: "เพาะเลี้ยงสัตว์น้ำ",
    patasPonds: "บ่อเลี้ยง Patas",
    pegamatanPonds: "บ่อเลี้ยง Pegamatan",
    pegamatanCages: "กระชังเลี้ยง Pegamatan",
    fishFarming: "ฟาร์มเพาะเลี้ยงปลา",
    shrimpFarmingWestBali: "ฟาร์มเพาะเลี้ยงกุ้งที่บาหลีตะวันตก",
    shrimpFarmingEastBali: "ฟาร์มเพาะเลี้ยงกุ้งที่บาหลีตะวันออก",
    watershed: "ลุ่มน้ำ",
    partners: "หุ้นส่วน",
    donors: "ผู้ให้ทุนสนับสนุน",
    landCover: "สิ่งปกคลุมดิน",
    all: "ทั้งหมด",
    cornFields: "ไร่ข้าวโพด",
    riceFields: "ไร่ข้าว",
    forests: "ป่าไม้",
    urbanAreas: "เขตเมือง",
    coffeeAndCoconutPlantations: "สวนมะพร้าวและกาแฟ",
    bareSoils: "พื้นที่โล่ง",
    shrub: "ไม้พุ่ม",
    wetlands: "พื้นที่ชุ่มน้ำ",
    fishPonds: "บ่อเลี้ยงปลา",
    fishCages: "กระชังเลี้ยงปลา",
    fishProduction: "การผลิตปลา",
    fishing: "ตกปลาสันทนาการ",
    shrimpPonds: "บ่อเลี้ยงกุ้ง",
    crabPonds: "บ่อเลี้ยงปู",
    selectLayersOnTheLeftSidebar: "เลือกชั้นข้อมูล (layers) จากแถบทางซ้าย",
    palm: "ปาล์ม",
    intensive: "เข้มข้น",
    semi: "กึ่งเข้มข้น",
    extensive: "ดั้งเดิม",
    settling: "ตั้งถิ่นฐาน",
    reservoir: "อ่างเก็บน้ำ",
    dormant: "บ่อน้ำนิ่ง",
    wastewaterTreatment: "การบำบัดน้ำเสีย",
    waterTreatment: "การบำบัดน้ำ",
    abandoned: "Abandoned",
    inactive: "Inactive",
    outlet: "Outlet",
    policulture: "Policulture",
    recreational: "Recreational",
    superIntensive: "Super intensive",
    eelPonds: "Eel ponds",
    softShellCrabPonds: "Soft shell crab ponds",
    grouperPonds: "Grouper ponds",
    snapperPonds: "Snapper ponds",
    country: "Country",
    continent: "Continent",
    species: "Species",
    regency: "Regency",
    areaM2: "Area (m2)",
    volM3: "Vol (m3)",
    district: "District",
    hectares: "Hectares", 
    province: "Province",
    estimatedProductionKgPerYear: "Estimated production (kg per year)",
    totalStockInd: "Total stock (ind.)",
    areaHa: {
      "bali": ["Land use area (hectares)", "Buleleng, Bali"], 
      "java": ["Land use area (hectares)", "Banyuwangi, East Java"]
    }, 
    totalNLoadsTonY: {
      "bali": ["Nitrogen loads by land use (tonnes/year)", "Buleleng, Bali"], 
      "java": ["Nitrogen loads by land use (tonnes/year)", "Banyuwangi, East Java"]
    },
    externalitiesKUsdY: {
      "bali": ["Externalities (K USD/Y)", "Buleleng, Bali"], 
    },
    shrimpAquacultureByType: {
      "java": ["Shrimp aquaculture by type (number)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureAreaHa: {
      "java": ["Shrimp aquaculture areas (hectares)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureTotalNLoads: {
      "java": ["Shrimp aquaculture nitrogen loads (tonnes/year)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureProduction: {
      "java": ["Shrimp aquaculture production (tonnes/year)", "Banyuwangi, East Java"]
    },
    shrimpAquaculture: "Shrimp aquaculture",
    ammonia: "Ammonia",
    din: "DIN",
    phytoplanktonBiomass: "Phytoplankton Biomass",
    zooplanktonBiomass: "Zooplankton Biomass",
  },
  fr: { // French
    language: "Langue",
		nitrogenTitle: "Exports d'azote total (organique + minéral), tonnes/an",
		phosphorusTitle: "Exports de phosphore total (organique + minéral), tonnes/an",
    nitrogenBarTitle: "Bilan d'azote (kg N par an)",
    excretion: "Excrétion",
    regeneration: "Régénération",
    algae: "Algues",
    naturalAreas: "Zones naturelles",
		annualCrops: "Cultures annuelles",
		permanentCrops: "Cultures permanentes",
		wastewaterUrbanAreas: "Eaux usées (zones urbaines)",
		region: "Région",
		subbasin: "Sous-bassin",
		aquascapeSustainableCarryingCapacity: "Capacité de charge durable Aquascape",
		flowM3S: "Débit (m3/s)",
		lengthMeters: "Longueur (mètres)",
		totalNitrogenConcentrationOrganicMineral: "Concentration en azote total (organique + minéral), en mg/L",
		totalPhosphorusConcentrationOrganicMineral: "Concentration en phosphore total (organique + minéral), en mg/L",
    contextDescr: "Analyse de l'aquaculture pour les régulateurs, les agriculteurs et les chaînes d'approvisionnement",
    selectLayersToTheRight: "Sélectionnez les couches de capacité de charge, de terre, d'océan et d'aquaculture dans la barre latérale gauche",
		hoverOverAreasOfInterestForMoreInformation: "Survolez les zones d'intérêt pour l'analyse AquaScape",
		clickAreaOfInterestToLockInformationInTheContextBar: "Cliquez sur la zone d'intérêt pour verouiller les informations dans le menu contextuel",
		zones: "Zones",
		carryingCapacity: "Capacité de charge",
		regions: "Régions",
		subbasins: "Sous-bassins",
		streams: "Rivières",
		bathymetry: "Bathymétrie",
		aquaculture: "Aquaculture",
		patasPonds: "Bassins de Pata",
		pegamatanPonds: "Bassin de Pegamatan",
		pegamatanCages: "Cages de Pegamatan",
		fishFarming: "Pisciculture",
		shrimpFarmingWestBali: "Elevage de crevettes, ouest de Bali",
		shrimpFarmingEastBali: "Elevage de crevettes, est de Bali",
		watershed: "Bassin versant",
		partners: "Partenaires",
		donors: "Donateurs",
    landCover: "Occupation des sols",
    all: "Tous",
    cornFields: "Champs de maïs",
    riceFields: "Rizières",
    forests: "Forêts",
    urbanAreas: "Zones urbaines",
    coffeeAndCoconutPlantations: "Plantations de café et de cocotier",
    bareSoils: "Sols nus",
    shrub: "Zones arbustives",
    wetlands: "Zones humides",
    fishPonds: "Bassin à poissons",
    fishCages: "Cages à poissons",
    fishProduction: "Production de poisson",
    fishing: "Pêche récréative",
    shrimpPonds: "Bassins à crevettes",
    crabPonds: "Bassins à crabes",
    selectLayersOnTheLeftSidebar: "Selectionnez les couches à afficher dans le menu gauche",
    palm: "Palmier",
    intensive: "Intensif",
    semi: "Semi",
    extensive: "Extensif",
    settling: "Dépôt",
    reservoir: "Réservoir",
    dormant: "Inexploité",
    wastewaterTreatment: "Traitement des eaux usées",
    waterTreatment: "Traitement de l'eau",
    abandoned: "Abandonné",
    inactive: "Inactif",
    outlet: "Exutoire",
    policulture: "Polyculture",
    recreational: "Récréatif",
    superIntensive: "Super intensif",
    eelPonds: "Bassins à anguilles",
    softShellCrabPonds: "Bassins à crabes à carapaces molles",
    grouperPonds: "Bassins à mérous",
    snapperPonds: "Bassins à vivaneaux",
    country: "Pays",
    continent: "Continent",
    species: "Espèces",
    regency: "Régence",
    areaM2: "Aire (m2)",
    volM3: "Vol (m3)",
    district: "District",
    hectares: "Hectares", 
    province: "Province",
    estimatedProductionKgPerYear: "Estimated production (kg per year)",
    totalStockInd: "Total stock (ind.)",
    areaHa: {
      "bali": ["Land use area (hectares)", "Buleleng, Bali"], 
      "java": ["Land use area (hectares)", "Banyuwangi, East Java"]
    }, 
    totalNLoadsTonY: {
      "bali": ["Nitrogen loads by land use (tonnes/year)", "Buleleng, Bali"], 
      "java": ["Nitrogen loads by land use (tonnes/year)", "Banyuwangi, East Java"]
    },
    externalitiesKUsdY: {
      "bali": ["Externalities (K USD/Y)", "Buleleng, Bali"], 
    },
    shrimpAquacultureByType: {
      "java": ["Shrimp aquaculture by type (number)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureAreaHa: {
      "java": ["Shrimp aquaculture areas (hectares)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureTotalNLoads: {
      "java": ["Shrimp aquaculture nitrogen loads (tonnes/year)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureProduction: {
      "java": ["Shrimp aquaculture production (tonnes/year)", "Banyuwangi, East Java"]
    },
    shrimpAquaculture: "Shrimp aquaculture",
    ammonia: "Ammonia",
    din: "DIN",
    phytoplanktonBiomass: "Phytoplankton Biomass",
    zooplanktonBiomass: "Zooplankton Biomass",
  },
  es: { // Spanish
    language: "Idioma",
    nitrogenTitle: "Exportación total de nitrógeno (orgánico + inorgánico), toneladas/año",
    phosphorusTitle: " Exportación total de fósforo (orgánico + inorgánico), toneladas/año",
    nitrogenBarTitle: "Balance de nitrógeno(kg N anuales)",
    excretion: "Excrección",
    regeneration: "Regeneración",
    algae: "Algas",
    naturalAreas: " Areas Naturales",
    annualCrops: "Cultivos Anuales",
    permanentCrops: "Cultivos Permanentes",
    wastewaterUrbanAreas: "Aguas residuales (de areas urbanas)",
    region: "Región",
    subbasin: "Subcuenca",
    aquascapeSustainableCarryingCapacity: "Aquascape Capacidad de Carga Sostenible",
    flowM3S: "Flujo (m3/s)",
    lengthMeters: "Largura (metros)",
    totalNitrogenConcentrationOrganicMineral: "Concentración Total de Nitrógeno (orgánico + inorgánico), en mg/L",
    totalPhosphorusConcentrationOrganicMineral: " Concentración Total de Fósforo (orgánico + inorgánico), en mg/L",
    contextDescr: "Análisis de acuicultura para reguladores, agricultores y cadenas de suministro",
    selectLayersToTheRight: "Seleccione las capas de capacidad de carga, tierra, océano y acuicultura en la barra lateral izquierda",
    hoverOverAreasOfInterestForMoreInformation: "Pase el cursor sobre las áreas de interés para el análisis de AquaScape",
    clickAreaOfInterestToLockInformationInTheContextBar: " Pinche sobre el área de interés para bloquear la información de la barra de contexto",
    zones: "Zonas",
    carryingCapacity: "Capacidad de Carga",
    regions: "Regiones",
    subbasins: "Subcuencas",
    streams: "Ríos",
    land: "Terreno",
    oceans: "Océanos",
    bathymetry: "Batimetría",
    aquaculture: "Acuicultura",
    patasPonds: "Estanques de Patas",
    pegamatanPonds: "Estanques de Pegamatan",
    pegamatanCages: "Jaulas de Pegamatan",
    fishFarming: "Cría de pescado",
    shrimpFarmingWestBali: "Cultivo de Camarón Oeste de Bali",
    shrimpFarmingEastBali: " Cultivo de Camarón Este de Bali",
    watershed: "Cuenca",
    partners: "Socios",
    donors: "Donante",
    landCover: "Cobertura Terrestre",
    all: "Todos",
    cornFields: "Campos de maiz",
    riceFields: " Campos de arroz",
    forests: "Bosques",
    urbanAreas: "Areas urbanas",
    coffeeAndCoconutPlantations: "Plantaciones de café y coco",
    bareSoils: "Suelo sin vegetación",
    shrub: "Arbusto",
    wetlands: "Zonas húmedas",
    fishPonds: "Estanques de pescado",
    fishCages: "Jaulas de pescado",
    fishProduction: "Producción de pescado",
    fishing: "Pesca recreativa",
    shrimpPonds: "Estanques de camarón",
    crabPonds: " Estanques de cangrejos",
    selectLayersOnTheLeftSidebar: "Selecciona capas en la barra lateral de la derecha",
    palm: "Palmera",
    intensive: "Intensivo",
    semi: "Semi",
    extensive: "Extensivo",
    settling: "Asentamiento",
    reservoir: "Reservorio",
    dormant: "Inactivo",
    wastewaterTreatment: "Tratamiento de aguas residuales",
    waterTreatment: " Tratamiento de aguas",
    abandoned: "Abandonado",
    inactive: "Inactivo",
    outlet: "Descarga",
    policulture: "Policultivo",
    recreational: "Recreativo",
    superIntensive: "Muy intensivo",
    eelPonds: "Estanques de anguila",
    softShellCrabPonds: " Estanques de cangrejos de caparazón suave",
    grouperPonds: "Estanques de mero",
    snapperPonds: "Estanques de pargo rojo",
    country: "País",
    continent: "Continente",
    species: "Especies",
    regency: "Regencia",
    areaM2: "Area (m2)",
    volM3: "Vol (m3)",
    district: "Distrito",
    hectares: "Hectáreas", 
    province: "Provincia",
    estimatedProductionKgPerYear: "Estimated production (kg per year)",
    totalStockInd: "Total stock (ind.)",
    areaHa: {
      "bali": ["Land use area (hectares)", "Buleleng, Bali"], 
      "java": ["Land use area (hectares)", "Banyuwangi, East Java"]
    }, 
    totalNLoadsTonY: {
      "bali": ["Nitrogen loads by land use (tonnes/year)", "Buleleng, Bali"], 
      "java": ["Nitrogen loads by land use (tonnes/year)", "Banyuwangi, East Java"]
    },
    externalitiesKUsdY: {
      "bali": ["Externalities (K USD/Y)", "Buleleng, Bali"], 
    },
    shrimpAquacultureByType: {
      "java": ["Shrimp aquaculture by type (number)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureAreaHa: {
      "java": ["Shrimp aquaculture areas (hectares)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureTotalNLoads: {
      "java": ["Shrimp aquaculture nitrogen loads (tonnes/year)", "Banyuwangi, East Java"]
    }, 
    shrimpAquacultureProduction: {
      "java": ["Shrimp aquaculture production (tonnes/year)", "Banyuwangi, East Java"]
    },
    shrimpAquaculture: "Shrimp aquaculture",
    ammonia: "Ammonia",
    din: "DIN",
    phytoplanktonBiomass: "Phytoplankton Biomass",
    zooplanktonBiomass: "Zooplankton Biomass",
  },
});